import FormTitle from '@core/components/FormTitle';
import { DateLabel, TextLabel } from '@core/components/Inputs';
import { Grid } from '@material-ui/core';
import { getCurrencySemSinalMonetario } from 'app/utils/monetarioUtil';
import React, { Fragment } from 'react';
import { useValorLiquidoInitialValue } from '../modal/compraInitialValues';

const CONTRUIBUINTES = {
  EMPRESA: 'Empresa',
  FORNECEDOR: 'Fornecedor',
};

const VisualizarCompraServico = ({ values }) => {
  const valorLiquido = useValorLiquidoInitialValue(values);
  return (
    <>
      <Grid container spacing={3} className="mb-4 mt-8">
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <TextLabel id="descricao" label="Descrição detalhada do serviço" value={values?.compraServico?.descricao} />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <TextLabel id="observacao" label="Observação" value={values?.observacao} />
        </Grid>
      </Grid>

      <FormTitle title="Informações da Nota Fiscal" />

      <Grid container spacing={3} className="mb-8">
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="municipio"
            label="Município da prestação do serviço"
            value={values?.compraServico?.notaFiscal?.municipio?.nome}
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="codigoServicoMunicipal"
            label="Código do serviço municipal"
            value={values?.compraServico?.notaFiscal?.codigoServicoMunicipal}
          />
        </Grid>
        <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
          <DateLabel id="dataEmissao" label="Data de emissão" value={values?.compraServico?.notaFiscal?.dataEmissao} />
        </Grid>
        <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
          <TextLabel id="serie" label="Série da NF" value={values?.compraServico?.notaFiscal?.serie} />
        </Grid>
        <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
          <TextLabel id="numero" label="Documento fiscal" value={values?.compraServico?.notaFiscal?.numero} />
        </Grid>
        {values?.compraServico?.retencoes?.map((retencao, index) => (
          <Fragment key={retencao?.id}>
            <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
              <TextLabel id={`imposto.${index}`} label="Imposto" value={retencao?.imposto?.nome} />
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
              <DateLabel id={`dataVencimento.${index}`} label="Data do vencimento" value={retencao?.dataVencimento} />
            </Grid>
            <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
              <TextLabel
                id={`valor.${index}`}
                label="Valor (R$)"
                value={getCurrencySemSinalMonetario(retencao?.valor)}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
              <TextLabel
                id={`contribuinte.${index}`}
                label="Contribuinte"
                value={CONTRUIBUINTES[retencao?.contribuinte]}
              />
            </Grid>
          </Fragment>
        ))}
        {values?.compraServico?.retencoes?.length > 0 && (
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <TextLabel
              id="valorLiquido"
              label="Valor líquido (R$)"
              value={getCurrencySemSinalMonetario(valorLiquido)}
            />
          </Grid>
        )}
      </Grid>
    </>
  );
};

export default VisualizarCompraServico;
